import { Web3Provider } from '@ethersproject/providers'

export default function getLibrary(provider: any): Web3Provider {
  // Pass "any" as the network to allow network changes without errors
  const library = new Web3Provider(provider, 'any')
  library.pollingInterval = 15000
  return library
}
